import { MediaAsset } from '@epicuro-next/data/merchandise';
import { createReducer, on } from '@ngrx/store';

import {
  loadPersonalMediaItems,
  loadPersonalMediaItemsError,
  loadPersonalMediaItemsSuccess,
} from './personal-media-items.actions';

export interface PersonalMediaItemsState {
  mediaItems: MediaAsset[];
  loading: boolean;
  error?: string;
}

export const initial: PersonalMediaItemsState = {
  mediaItems: [],
  loading: false,
};

export const personalMediaItemsReducer = createReducer<PersonalMediaItemsState>(
  initial,
  on(loadPersonalMediaItems, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),
  on(loadPersonalMediaItemsSuccess, (state, action) => {
    return {
      ...state,
      mediaItems: action.mediaItems,
      loading: false,
    };
  }),
  on(loadPersonalMediaItemsError, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
);
